module.exports = __webpack_public_path__ + "img/delete.485d5755.svg";